/* eslint-disable react/no-this-in-sfc,array-callback-return,no-underscore-dangle,no-unused-vars,no-plusplus */

import React from 'react'
import { BarElement, CategoryScale, Chart as ChartJS, LinearScale } from 'chart.js'
import { Bar } from 'react-chartjs-2'
import PropTypes from 'prop-types'
import styled from 'styled-components'

ChartJS.register(CategoryScale, LinearScale, BarElement)

const BarChartStyled = styled.div`
  display: inline-block;
  width: 65%;
`

const ChartBar = ({ data }) => {
  if (!data || !Array.isArray(data) || data.length === 0) {
    return null
  }

  const options = {
    events: [],
    responsive: true,
    plugins: {
      annotation: {
        annotations: {
          type: 'box',
          xMin: 2.5,
          xMax: 3.5,
          yMin: 0,
          yMax: 100,
          backgroundColor: 'rgba(250, 250, 0, 0.4)',
          borderColor: 'rgba(0, 150, 0, 0.2)',
          drawTime: 'beforeDatasetsDraw',
          borderWidth: 0,
          borderRadius: 0
        }
      }
    },
    scales: {
      x2: {
        axis: 'x',
        position: 'bottom',
        labels: data && data.map((item) => item.series),
        ticks: {
          color: 'rgba(0,0,0,0)'
        },
        grid: {
          display: false
        }
      },
      x1: {
        axis: 'x',
        position: 'bottom',
        ticks: {
          callback(value) {
            return this.getLabelForValue(value)
          }
        },
        grid: {
          display: false
        }
      },
      y: {
        suggestedMin: 0,
        suggestedMax: 100,
        ticks: {
          callback(value) {
            return this.getLabelForValue(value)
          }
        }
      }
    },
    parsing: {
      xAxisKey: 'year',
      yAxisKey: 'arr'
    }
  }

  const labels = data && data.map((label) => label.year)

  const chartsData = {
    labels,
    datasets: [
      {
        backgroundColor: '#061274',
        data
      }
    ]
  }

  const canvasBackgroundColor = {
    id: 'canvasBackgroundColor',
    afterDatasetsDraw(chart) {
      const { ctx, chartArea, scales } = chart
      if (!chartArea || !scales?.x1) return
      const { top, height } = chartArea
      const x1 = scales.x1
      ctx.save()
      // ctx.fillStyle = '#FFFDC4'
      // eslint-disable-next-line no-underscore-dangle,array-callback-return
      const ipo = {
        begin: 0,
        end: 0
      }
      let diff = false
      const dataset = chart.config._config.data.datasets[0].data || []

      let label = {
        value: dataset[0]?.series,
        begin: 0,
        end: 0
      }
      const width = x1.getPixelForValue(1.5) - x1.getPixelForValue(0.5)
      dataset.map((item, index) => {
        ctx.textAlign = 'center'
        if (!item.series) return

        if (index > 0) {
          if (label.value !== item.series) {
            const center = x1.getPixelForValue(label.begin - 1 / 2)
                + ((label.end - label.begin + 1) * width) / 2
            if (label.value) {
              ctx.fillStyle = '#000'
              ctx.font = '600 12px Verdana'
              // const labelValue = label.value === 'IPO' ? 'IPO' : `Series ${label.value}`
              ctx.fillText(label.value || '', center, top + height + 22)
              ctx.fillRect(
                x1.getPixelForValue(label.begin - 1 / 2) + 5,
                top + height + 5,
                (label.end - label.begin + 1) * width - 10,
                3
              )
            }
            if (label.value === 'IPO') {
              ctx.fillStyle = 'rgba(255,253,196,0.2)'
              ctx.fillRect(
                x1.getPixelForValue(label.begin - 1 / 2),
                top,
                (label.end - label.begin + 1) * width,
                height
              )
              ctx.fillStyle = 'red'
              ctx.font = '500 16px Verdana'
              ctx.fillText('IPO', center, 50)
            }
            label.begin = index
            label.value = item.series
          }
          label.end = index
        }
      })

      if (label.value) {
        ctx.fillStyle = '#000'
        ctx.font = '600 12px Verdana'
        const center = x1.getPixelForValue(label.begin - 1 / 2) + ((label.end - label.begin + 1) * width) / 2
        // const labelValue = label.value === 'IPO' ? 'IPO' : `Series ${label.value}`
        ctx.fillText(label.value, center, top + height + 22)
        ctx.fillRect(
          x1.getPixelForValue(label.begin - 1 / 2) + 5,
          top + height + 5,
          (label.end - label.begin + 1) * width - 10,
          3
        )

        if (label.value === 'IPO') {
          ctx.fillStyle = 'rgba(255,253,196,0.5)'
          ctx.fillRect(
            x1.getPixelForValue(label.begin - 1 / 2),
            top,
            (label.end - label.begin + 1) * width,
            height
          )
          ctx.fillStyle = 'red'
          ctx.font = '500 16px Verdana'
          ctx.fillText('IPO', center, 50)
        }
      }
    }
  }
  const plugins = [canvasBackgroundColor]

  return (
    <BarChartStyled>
      <Bar options={options} data={chartsData} plugins={plugins} />
    </BarChartStyled>
  )
}

ChartBar.propTypes = {
  data: PropTypes.array
}

export default React.memo(ChartBar)
